import React, {Component} from "react";
import FlexView from "react-flexview";
import {Tab, TabList, TabPanel, Tabs} from "react-tabs";
import DailySalesReport from "./dailySalesReport";
import MonthToDateSales from "./monthToDateSales";
import YearToDateSales from "./yearToDateSales";
import LastThreeYearsSales from "./lastThreeYearsSales";
import DailyReportBySales from "./dailyReportBySales";
import Api from "../../../../../Services/Api";
import {mapToObjectDDL} from "../../../../common/mapper";
import Container from "../../../../../modules/commons/Container";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import { fetchDataAsync } from "../../../../../Services/Utils";
import SimpleLoadingOverlay from "../../../../../modules/popup/SimpleLoadingOverlay";
import { connect } from "react-redux";
import ErrorAction from "../../../../../Redux/ErrorRedux";


class SalesReport extends Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            dataCabang: [],
            dataSales: [],
            kodeCabang: null,
            sales: null,
            selectedCabang: null,
            selectedSales: null,
            idLeader:null,
            search:{
                selectedSales:null,
                selectedCabang:null
            }
        };
    };

    componentDidMount = async () => {
        this.fetchDataCabang();
        this.fetchLeaderId();
    }

    fetchLeaderId = async () => {
      const idLeader = localStorage.getItem("idLeader");
      const userId = localStorage.getItem("userId");
      if (idLeader) {
        this.setState((prevValue) => ({
          ...prevValue,
          idLeader: idLeader,
        }));
        return;
      }
      this.handleTriggerLoading();
      try {
        let res = await fetchDataAsync({
          asyncFn: () => Api.create("NAGAMAS_MASTER_DATA").findUserById(userId),
          menuName:
            "Dashboard Level Kepala Cabang Keatas - Laporan Harian By Team Leader",
          setError: this.props.setError,
        });
        if (res.ok) {
          localStorage.setItem("idLeader", res.data.data.id);
          this.setState((prevValue) => ({
            ...prevValue,
            idLeader: res.data.data.id,
          }));
        }
      } catch (error) {
        console.log("errors: ", error);
      }
      this.handleTriggerLoading();
    }

    fetchDataCabang = async () => {
        try {
            let res = await Api.create("NAGAMAS_MASTER_DATA").findAllMasterCabang();
            if (res.ok) {
                let filteredData = res.data.data.filter(
                    item => this.props.menuAccess.map(data => data.idRefObj).includes(item.kodeCabang)
                );

                if (filteredData.length !== 0) {
                    this.setState((prevValue) => ({
                      ...prevValue,
                      dataCabang: filteredData,
                      kodeCabang: mapToObjectDDL(
                        filteredData[0].namaDealer,
                        filteredData[0].kodeCabang
                      ),
                      search: {
                        selectedCabang: filteredData[0].kodeCabang,
                        selectedSales: null,
                      },
                    }));
                    await this.fetchDataSales(filteredData[0].kodeCabang);
                }
            }
        } catch (error) {
            console.log("errors", error);
        }
    };

    fetchDataSales = async (value) => {
        console.log(this.props.user.user);
        
        try {
            let res = await Api.create("NAGAMAS_MASTER_DATA").getSalesDropdownForDashboard({
                employeeIdTeamLeader: this.state.idLeader,
                kodeCabang: value,
            });
            if (res.ok) {
                this.setState((prevValue) => ({
                    ...prevValue,
                    dataSales: res.data.data,
                }));
            }
        } catch (error) {
            console.log("errors", error);
        }
    };

    handleSearchValueChange = (name, value) => {
        this.setState((prevValue) => ({
            ...prevValue,
            [name]: value,
        }));
    };

    handleChangeCabang = (value) => {
        this.handleSearchValueChange("kodeCabang", value);
        this.setState((prevValue) => ({
            ...prevValue,
            sales: null,
            search: {
                ...prevValue.search,
                selectedSales: null,
            },
        }));
        if(!value) return
        this.fetchDataSales(value.value);
    };

    handleSearch = () => {
        // if(this.state.sales?.value){
          this.setState((prevValue) => ({
            ...prevValue,
            search: {
              selectedCabang: this.state.kodeCabang.value || null,
              selectedSales: this.state?.sales?.value || null,
            },
          }));
        // }else{
        //     this.props.setError({
        //       menuName: "Dashboard Salesman - Laporan Jualan Harian",
        //       errorMessage: "Sales Belum di pilih",
        //     });
        // }
        
    };

    handleTriggerLoading = () => {
        this.setState((prevValue) => ({...prevValue, loading: !prevValue.loading}));
    };

    render() {
        return (
            <>
                <Container>
                    <FlexView style={{gap: "20px", alignItems: "center"}}>
                        <SimpleDDL
                            id="select_options_kode_cabang"
                            box="search"
                            name="kodeCabang"
                            containerclassname="width width-250px"
                            placeholder="Nama Cabang"
                            menuPosition="fixed"
                            isClearable
                            options={
                                this.state.dataCabang.map(
                                    item => mapToObjectDDL(item.namaDealer, item.kodeCabang)
                                )
                            }
                            value={this.state.kodeCabang}
                            onChange={(value) => this.handleChangeCabang(value)}
                        />
                        <SimpleDDL
                            id="select_options_sales"
                            box="search"
                            name="sales"
                            containerclassname="width width-250px"
                            placeholder="Nama Sales"
                            menuPosition="fixed"
                            isClearable
                            options={
                                this.state.dataSales.map(
                                    item => mapToObjectDDL(item.name, item.employeeId)
                                )
                            }
                            value={this.state.sales}
                            onChange={(value, {name}) => this.handleSearchValueChange(name, value)}
                        />
                        <SimpleButton
                            styles={{marginBottom: "15px"}}
                            onClick={()=>this.handleSearch()}
                        >Cari</SimpleButton>
                    </FlexView>
                    <Tabs>
                        <TabList>
                            <Tab>Laporan Jualan Harian</Tab>
                            <Tab>Laporan Jualan Harian By Sales/CS</Tab>
                            <Tab>Laporan Jualan Month To Date</Tab>
                            <Tab>Laporan Year To Date</Tab>
                            <Tab>Laporan Jualan 3 Tahun Terakhir</Tab>
                        </TabList>
                        <TabPanel>
                            <DailySalesReport
                                {...this.props}
                                search={this.state.search}
                                idLeader={this.state.idLeader}
                                triggerLoading={this.handleTriggerLoading}
                            />
                        </TabPanel>
                        <TabPanel>
                            <DailyReportBySales
                                {...this.props}
                                search={this.state.search}
                                idLeader={this.state.idLeader}
                                triggerLoading={this.handleTriggerLoading}
                            />
                        </TabPanel>
                        <TabPanel>
                            <MonthToDateSales
                                {...this.props}
                                search={this.state.search}
                                idLeader={this.state.idLeader}
                                triggerLoading={this.handleTriggerLoading}
                            />
                        </TabPanel>
                        <TabPanel>
                            <YearToDateSales
                                {...this.props}
                                search={this.state.search}
                                idLeader={this.state.idLeader}
                                triggerLoading={this.handleTriggerLoading}
                            />
                        </TabPanel>
                        <TabPanel>
                            <LastThreeYearsSales
                                {...this.props}
                                search={this.state.search}
                                idLeader={this.state.idLeader}
                                triggerLoading={this.handleTriggerLoading}
                            />
                        </TabPanel>
                    </Tabs>
                    {this.state.loading && <SimpleLoadingOverlay active={this.state.loading}/>}
                </Container>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.user,
        auth: state.auth,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        setError: (payload) => dispatch(ErrorAction.setError(payload)),
    };
};

export default connect(mapStateToProps,mapDispatchToProps)(SalesReport);